<template>
  <b-overlay
    :show="loader.pagina"
    opacity="0.50"
    rounded="sm"
  >
    <section>
      <!-- content -->
      <b-row class="match-height">
        <b-col
          id="'option-moodle-prof"
          md="3"
          sm="6"
        >
          <botonsalonclase />
        </b-col>
        <!-- list dinamic -->
        <b-col
          v-for="item in kbasesores"
          :id="'option-'+item.id"
          :key="item.id"
          md="3"
          sm="6"
        >
          <b-card
            :class="item.cls"
            :img-src="require('@/assets/images/illustration/' + item.img)"
            :img-alt="item.img.slice(5)"
            img-top
            @click="$router.push({ name: item.goahead })"
          >
            <h4>{{ item.title }}</h4>
            <b-card-text class="mt-1">
              {{ item.desc }}
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </b-overlay>
</template>
<script>
import {
  BRow, BCol, BCard, BCardText, BOverlay,
} from 'bootstrap-vue'
import store from '@/store'
import { getData } from '@core/utils/http/general'
import botonsalonclase from '@/views/campus/components/salondeclase/boton.vue'

/* eslint-disable global-require */
export default {
  name: 'DashAlumno',
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BOverlay,
    botonsalonclase,
  },
  data() {
    return {
      loader: {
        pagina: false,
      },
      kbasesores: [],
    }
  },
  mounted() {
    this.get_data()
  },
  methods: {
    get_data() {
      this.loader.pagina = true
      getData({ action: 9, token: store.state.cuenta.session.token }, 'wsadminpagecampus')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) this.kbasesores = response.data.data
          else {
            this.$bvToast.toast(response.data.message, {
              title: `${response.data.status} - Sección en construcción`,
              variant: 'danger',
              solid: true,
            })
          }
          this.loader.pagina = false
        }).catch(err => {
          this.loader.pagina = false
          this.$bvToast.toast(err, {
            title: 'Error, No hay conexión',
            variant: 'danger',
            solid: true,
          })
        })
    },
  },
}
</script>
<style scoped>
.importanteItem {
  border: 1px solid #7367f0;
}
</style>
